import HomeNav from "@/pages/home/components/HomeNav";
import HeroSection from "@/pages/home/components/HeroSection";
import HighlightsSection from "@/pages/home/components/HighlightsSection";
import RankingSection from "@/pages/home/components/RankingSection";
import CollectionsSection from "@/pages/home/components/CollectionsSection";
import GenreSection from "@/pages/home/components/GenreSection";
import EditorPicksSection from "@/pages/home/components/EditorPicksSection";
import NewArrivalsSection from "@/pages/home/components/NewArrivalsSection";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <HomeNav />
      <main>
        <HeroSection />
        <HighlightsSection />
        <RankingSection />
        <CollectionsSection />
        <GenreSection />
        <EditorPicksSection />
        <NewArrivalsSection />
        <GuideSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}